/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Resquest with id of week models
 * @export
 * @interface WeekModelIdsRequest
 */
export interface WeekModelIdsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof WeekModelIdsRequest
     */
    weekModelIds?: Array<string>;
}

/**
 * Check if a given object implements the WeekModelIdsRequest interface.
 */
export function instanceOfWeekModelIdsRequest(value: object): value is WeekModelIdsRequest {
    return true;
}

export function WeekModelIdsRequestFromJSON(json: any): WeekModelIdsRequest {
    return WeekModelIdsRequestFromJSONTyped(json, false);
}

export function WeekModelIdsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeekModelIdsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'weekModelIds': json['weekModelIds'] == null ? undefined : json['weekModelIds'],
    };
}

export function WeekModelIdsRequestToJSON(json: any): WeekModelIdsRequest {
    return WeekModelIdsRequestToJSONTyped(json, false);
}

export function WeekModelIdsRequestToJSONTyped(value?: WeekModelIdsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'weekModelIds': value['weekModelIds'],
    };
}

